const getHighlightedText = (text, highlights) => {
    if (!text) return null;
    if (!highlights || highlights.length === 0) return text;

    const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const uniqueHighlights = new Map();
    highlights.forEach((highlight) => {
        const trimmedHighlight = typeof highlight === 'string' ? highlight.trim() : '';
        if (trimmedHighlight) {
            uniqueHighlights.set(trimmedHighlight.toLowerCase(), trimmedHighlight);
        }
    });
    const sortedHighlights = [...uniqueHighlights.values()].sort((a, b) => b.length - a.length);
    if (sortedHighlights.length === 0) return text;

    const wordCharacters = '\\p{L}\\p{N}\\p{M}';
    const regex = new RegExp(
        `(^|[^${wordCharacters}])(${sortedHighlights.map(escapeRegExp).join('|')})(?=$|[^${wordCharacters}])`,
        'giu'
    );
    const parts = text.split(regex);

    return parts.map((part, index) => {
        const isMatch = sortedHighlights.some(
            (highlight) => highlight.toLowerCase() === part.toLowerCase()
        );

        return isMatch ? (
            <span className='highlightedTopic' key={index}>{part}</span>
        ) : (
            <span key={index}>{part}</span>
        );
    });
};

const PreviewInfoSummary = ({ summary, topics, leadingText, className = 'previewInfoSummary', style }) => {
    const trimmedLeadingText = typeof leadingText === 'string' ? leadingText.trim() : '';
    const trimmedSummary = typeof summary === 'string' ? summary.trim() : '';

    if (!trimmedLeadingText && !trimmedSummary) {
        return null;
    }

    return (
        <div className={className} style={style}>
            {!!trimmedLeadingText && <span>{trimmedLeadingText}</span>}
            {!!trimmedLeadingText && !!trimmedSummary && <span> · </span>}
            {!!trimmedSummary && getHighlightedText(trimmedSummary, topics)}
        </div>
    );
};

export default PreviewInfoSummary;
